import { Stack, Typography } from '@mui/material';
import { crowdsaleModel } from 'entities/crowdsale';
import { formatToken, fromDecimals, useShallowSelector } from 'shared';

export const CrowdsalePrice = () => {
  const { cratPrice } = useShallowSelector(crowdsaleModel.selectors.getCrowdsale);

  return (
    <Stack mt={1} direction="row" justifyContent="space-between">
      <Stack>
        <Typography>Current Price</Typography>
        <Typography className="secondary">{formatToken(fromDecimals(cratPrice))} USD</Typography>
      </Stack>
      <Stack alignItems="flex-end">
        <Typography>Listing Price</Typography>
        <Typography className="secondary">0.81 USD</Typography>
      </Stack>
    </Stack>
  );
};
